"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuickAmountsSettings = void 0;
const react_1 = require("react");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const api_1 = require("./api");
const utils_1 = require("./utils");
const useQuickAmountsSettings = (defaultSettings) => {
    const { data, isLoading } = (0, api_1.useGetProfileSettings)();
    const quickAmounts = (0, utils_1.getQuickAmounts)(defaultSettings, data === null || data === void 0 ? void 0 : data.settings, data === null || data === void 0 ? void 0 : data.quickAmounts);
    const resetSettingsEnabled = !(0, react_fast_compare_1.default)(quickAmounts, defaultSettings);
    return (0, react_1.useMemo)(() => ({
        isLoading,
        quickAmountsSettings: quickAmounts,
        resetSettingsEnabled,
    }), [isLoading, quickAmounts, resetSettingsEnabled]);
};
exports.useQuickAmountsSettings = useQuickAmountsSettings;
//# sourceMappingURL=useQuickAmountsSettings.js.map